export class SearchResult{
    public categories:SearchCategory[];

    constructor(){
        this.categories=[];
        this.categories.push(new SearchCategory("Places","place")); 
        this.categories.push(new SearchCategory("Listings","store"));
        this.categories.push(new SearchCategory("Other","place"));
        this.categories.push(new SearchCategory("Text Search","spellcheck"));
    }
}

export class SearchCategory{
    public name:string;
    public icon:string;
    public items:SearchItem[];
    constructor(name:string, icon:string){
        this.name=name;
        this.icon=icon;
        this.items=[];
    }
}

export class SearchItem{
    public result:any;
    public resultType:string; //can be like city, county, state, address
    public propertyIds:number[];
    constructor(result:any, resultType:string){
        this.result=result;
        this.resultType=resultType;
        this.propertyIds=[];
    }
    get resultDescription(){
        return this.result + " (" + this.resultType[0].toUpperCase() + this.resultType.substring(1) + ")";
    }
}